module.exports = __webpack_public_path__ + "static/media/weikang4.b5b223bd.png";